import { render, staticRenderFns } from "./createForm.vue?vue&type=template&id=4c48f51b&"
import script from "./createForm.vue?vue&type=script&lang=js&"
export * from "./createForm.vue?vue&type=script&lang=js&"
import style0 from "./createForm.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports